import { render, staticRenderFns } from "./MinusSvg.vue?vue&type=template&id=fed25c80&"
import script from "./MinusSvg.vue?vue&type=script&lang=js&"
export * from "./MinusSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports